<template>
  <aside
    :class="{ 'collapsed': $store.state.optionsCollapsed }"
    v-on:scroll="$event.stopPropagation()">
    <header
      v-touch:swipe.bottom="collapse"
      v-touch:swipe.top="expand"
      v-on:click="setCollapsed(!$store.state.optionsCollapsed)" class="top-header">
      <h5 v-if="getT">{{getT.static.customizer[0].options_container[0].heading}}</h5>
      <svg
        class="arrow"
        :class="{ 'flip': $store.state.optionsCollapsed }"
        src="./../../assets/icons/right-arrow-small.svg"
        alt="Dropdown arrow"
        xmlns="http://www.w3.org/2000/svg" width="9.14" height="14.6" viewBox="0 0 9.14 14.6"><path class="a" d="M5.17,15.3,3.42,13.51l5.6-5.44L3.52,2.45,5.31.7l7.25,7.41Z" transform="translate(-3.42 -0.7)"/></svg>
    </header>
    <div class="container" id="options-accessories">
      <OptionList :collapsed="$store.state.optionsCollapsed"/>
      <FinishingOptionList :collapsed="$store.state.optionsCollapsed"/>
      <AccessoryList :collapsed="$store.state.optionsCollapsed"/>
    </div>
  </aside>
</template>
<script>
import OptionList from './OptionList'
import FinishingOptionList from './FinishingOptionList'
import AccessoryList from './../accessories/AccessoryList'
import { breakpoint } from '../../styles/style';
import { mapGetters } from 'vuex';

export default {
  name: 'OptionsContainer',
  components: {
    OptionList,
    FinishingOptionList,
    AccessoryList,
  },
  computed: {
    ...mapGetters(['getT']),
  },
  methods: {
    setCollapsed(collapsed) {
      // Only collapse if mobile
      if (document.body.clientWidth <= breakpoint.xl) {
        this.$store.commit('setCollapsed', collapsed);
        this.updateCanvasDimensions();
      }
    },
    collapse() {
      if (!this.$store.state.optionsCollapsed && document.body.clientWidth <= breakpoint.xl) {
        this.$store.commit('setCollapsed', true);
        this.updateCanvasDimensions();
      }
    },
    expand() {
      if (this.$store.state.optionsCollapsed) {
        this.$store.commit('setCollapsed', false);
        this.updateCanvasDimensions();
      }
    },
    // Update PlayCanvas dimensions every 20ms for <duration>ms
    updateCanvasDimensions: function() {
      setTimeout(() => {
        // Push new frame
        if (window.RenderCenter) {
          window.RenderCenter.renderRequested = true;
        }
      }, 500);
    },
  },
}
</script>
<style scoped lang="scss">
aside {
  position: absolute;
  bottom: 4em;
  width: 100vw;
  height: 45%;
  display: flex;
  flex-direction: column;
  background-color: $deep-navy;
  transition: height 400ms cubic-bezier(0.645, 0.045, 0.355, 1);
  animation: fly-in 600ms cubic-bezier(0.215, 0.610, 0.355, 1);
  @keyframes fly-in {
    from { transform: translateY(6em); opacity: 0; }
  }
  &.collapsed {
    height: 3.25em;
  }
  header {
    z-index: 2;
    display: flex;
    justify-content: space-between;
    padding: 1em 1em .875em 1em;
    border-bottom: 1px solid $deep-slate;
    background-color: $shallow-navy;
    h5 {
      color: $off-muted-white;
    }
    .arrow {
      path.a { fill: $semi-muted-white; }
      margin: .25em .75em 0 .5em;
      transform: rotate(90deg);
      &.flip {
        transform: rotate(-90deg);
      }
      @media #{ $desktop } {
        display: none;
      }
    }
  }
  & > header {
    position: absolute;
    top: 0;
    width: 100%;
  }
  .container {
    height: 100%;
    padding-top: .5em;
    overflow-y: auto;
    overflow-x: hidden; // iOS - prevent horizontal drag
    &::after {
      content: '';
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: calc(100% - #{ $scrollbar-width });
      height: 5em;
      background: linear-gradient(rgba(16, 28, 48, 0), #101c30);
      pointer-events: none; // Don't block clicks on option/accessory components
    }
  }
  @media #{$tablet-only} {
    max-height: calc(100% - #{ $min-3d-viewport } - #{ $bottom-bar-height });
  }
  @media #{$desktop} {
    top: 0;
    right: 0;
    width: $aside-desktop-width;
    min-width: $min-aside-desktop-width;
    max-width: $max-aside-desktop-width;
    height: calc(100% - #{ $desktop-bottom-bar-height });
    & > header {
      position: relative;
    }
    .container, .options-container {
      padding-top: 0;
    }
  }
  // Make more room for options on phones/tablets in horizontal orientation
  @media only screen and (max-width: 1020px) and (min-aspect-ratio: 5/4) {
    &:not(.collapsed) {
      max-height: calc(100% - 4em);
    }
  }
  // Mobile - horizontal orientation
  @media only screen and (max-width: 1020px) and (min-aspect-ratio: 5/4) {
    transition: max-height 400ms cubic-bezier(0.645, 0.045, 0.355, 1);
    &.collapsed {
      max-height: 3.25em;
      height: 100%;
    }
    &:not(.collapsed) {
      max-height: calc(100% - 4em);
      height: calc(100% - 4em);
    }
  }
}
</style>
